export default __webpack_public_path__ + "static/media/sample-staff.7d2003fb.png";